<template>
  <div id="CustomerPage">
    <section class="section">
      <div class="container">
        <h1 class="title is-primary" style="color: #00AEEF; font-weight: 100;">
          {{ $t("customer.title") }}
        </h1>

        <!-- Search Customer Section -->
        <div class="columns">
          <!-- Input Field -->
          <div class="column is-5-desktop is-8-tablet is-12-mobile">
            <b-field>
              <b-input
                type="search"
                icon="magnify"
                custom-class="dtac-font"
                v-model="searchText"
                :placeholder="$t('customer.search.title')"
                @keyup.native.enter="searchSpecifiedCustomer"
              />
            </b-field>
          </div>

          <!-- Button Search -->
          <div class="column is-1-desktop is-2-tablet is-12-mobile">
            <b-button
              class="full-width dtac-font"
              type="is-primary"
              @click="searchSpecifiedCustomer"
              >{{ $t("customer.search.button") }}</b-button
            >
          </div>

          <!-- Dropdown Calendar -->
          <div
            class="column is-2-desktop is-12-mobile is-offset-4"
            style="text-align: right;"
          >
            <b-dropdown
              v-model="backwardDays"
              aria-role="list"
              position="is-bottom-left"
            >
              <button class="button dtac-font" type="button" slot="trigger">
                <template>
                  <b-icon icon="calendar-search" />
                  <span v-if="backwardDays === 1">{{
                    $t("customer.options.yesterday")
                  }}</span>
                  <span v-else-if="backwardDays === 2">{{
                    $t("customer.options.threedays")
                  }}</span>
                  <span v-else-if="backwardDays === 7">{{
                    $t("customer.options.week")
                  }}</span>
                  <span v-else-if="backwardDays === 30">{{
                    $t("customer.options.month")
                  }}</span>
                  <span v-else>{{ $t("customer.options.all") }}</span>
                </template>
                <b-icon icon="menu-down"></b-icon>
              </button>

              <b-dropdown-item :value="1" aria-role="listitem">
                <div class="media">
                  <div class="media-content">
                    <h3>{{ $t("customer.options.yesterday") }}</h3>
                  </div>
                </div>
              </b-dropdown-item>

              <b-dropdown-item :value="2" aria-role="listitem">
                <div class="media">
                  <div class="media-content">
                    <h3>{{ $t("customer.options.threedays") }}</h3>
                  </div>
                </div>
              </b-dropdown-item>
              <b-dropdown-item :value="7" aria-role="listitem">
                <div class="media">
                  <div class="media-content">
                    <h3>{{ $t("customer.options.week") }}</h3>
                  </div>
                </div>
              </b-dropdown-item>
              <b-dropdown-item :value="30" aria-role="listitem">
                <div class="media">
                  <div class="media-content">
                    <h3>{{ $t("customer.options.month") }}</h3>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div v-if="searchedCustomers.length > 1 && !hideTable">
          <customer-table
            :customers="searchedCustomers"
            @row_selected="hideTable = true"
          />
        </div>
        <router-view @on_rollback="refreshCustomerPage()" />
      </div>
    </section>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";
import CustomerTable from "@/components/tables/CustomerTable.vue";

export default {
  name: "CustomerPage",
  components: {
    CustomerTable
  },
  data() {
    return {
      hideTable: false,
      backwardDays: null,
      searchText: null,
      searchedCustomers: [],
      searchedCustomerNumber: null
    };
  },
  watch: {
    backwardDays: function(val) {
      if (val) {
        this.searchText = null;
        this.searchBackwardCustomer(val);
      }
    }
  },
  methods: {
    refreshCustomerPage: function() {
      this.$router.replace({ name: "customers" });
      if (this.backwardDays) {
        this.searchBackwardCustomer(this.backwardDays);
      }
    },
    /*
     Request for searching a matched msisdn, imei, or serial no. customer.
    */
    searchSpecifiedCustomer: async function() {
      if (this.$route.name === "customers-deatil") {
        this.$router.replace({ name: "customers" });
      } else {
        this.$router.replace({
          name: "customers",
          query: { search: this.searchText }
        });
      }

      if (this.searchText && this.searchText > 0) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        let searchNumber = this.searchText;
        switch (searchNumber.length) {
          case 4:
            searchNumber = "6666032" + this.searchText;
            break;
          case 5:
            searchNumber = "666603" + this.searchText;
            break;
          default:
            searchNumber = this.searchText;
            break;
        }
        const searchResult = await CustomerApiManager.requestSearchCustomer(
          searchNumber
        );
        loadingComponent.close();

        switch (searchResult.code) {
          case "0":
            this.hideTable = false;
            this.backwardDays = null;
            this.searchedCustomers = [];

            this.searchedCustomers = searchResult.data;
            if (this.searchedCustomers.length === 1) {
              this.navigateToCustomerDetail(this.searchedCustomers[0]._id);
            }
            break;

          default:
            this.searchText = null;
            AlertManager.showErrorSnackbar(searchResult.message);
            break;
        }
      }
    },
    searchBackwardCustomer: async function(days) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });

      if (this.$route.name === "customers-deatil") {
        this.$router.replace({ name: "customers" });
      } else {
        this.$router.replace({ name: "customers", query: { search: days } });
      }

      const searchResult = await CustomerApiManager.requestBackwardCustomer(
        days
      );
      loadingComponent.close();

      switch (searchResult.code) {
        case "0":
          this.hideTable = false;
          this.searchedCustomers = searchResult.data.reverse();
          if (this.searchedCustomers.length === 1) {
            this.navigateToCustomerDetail(this.searchedCustomers[0]._id);
          }
          break;

        default:
          this.searchText = null;
          AlertManager.showErrorSnackbar(searchResult.message);
          break;
      }
    },
    navigateToCustomerDetail: function(_id) {
      this.hideTable = true;
      this.$router.push({ name: "customers-deatil", params: { id: _id } });
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (from.name === "customers-deatil") {
      this.hideTable = false;
    }
    next();
  }
};
</script>
